var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardImageStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#032339"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_963_4576",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 34,
    height: 34
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 16.875,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_963_4576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.9722,
    cy: 5.12795,
    r: 14.0005,
    transform: "rotate(-22 16.9722 5.12795)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.0293,
    cy: 44.8711,
    r: 14.0005,
    transform: "rotate(-22 33.0293 44.8711)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.1289,
    cy: 33.0283,
    r: 14.0005,
    transform: "rotate(-22 5.1289 33.0283)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5039,
    cy: 16.0611,
    r: 14.0005,
    transform: "rotate(-22 44.5039 16.0611)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImageStar);
export default __webpack_public_path__ + "static/media/Card-ImageStar.571c2e4e6a07815cf4b4bf0d2a5724a4.svg";
export { ForwardRef as ReactComponent };